import { useCharacterizationStore } from '@/shared/stores/characterization.store';
import { useCallback } from 'react';

/**
 * Hook Facade para interactuar con el store de characterization
 * Siguiendo el patrón de useAppCareerLayer
 * Proporciona una API estable y segura para evitar bucles infinitos
 */
export const useAppCharacterization = () => {
  const apiData = useCharacterizationStore((state) => state.apiData);
  const isLoading = useCharacterizationStore((state) => state.isLoading);
  const actionTypes = useCharacterizationStore((state) => state.actionTypes);
  const riskTypes = useCharacterizationStore((state) => state.riskTypes);
  const catalogsLoaded = useCharacterizationStore(
    (state) => state.catalogsLoaded,
  );

  const loadData = useCharacterizationStore((state) => state.loadData);
  const loadActionTypes = useCharacterizationStore(
    (state) => state.loadActionTypes,
  );
  const loadRiskTypes = useCharacterizationStore(
    (state) => state.loadRiskTypes,
  );
  const setLoading = useCharacterizationStore((state) => state.setLoading);
  const clearData = useCharacterizationStore((state) => state.clearData);

  const handleSetLoading = useCallback(
    (loading: boolean) => {
      setLoading(loading);
    },
    [setLoading],
  );

  const handleClearData = useCallback(() => {
    clearData();
  }, [clearData]);

  return {
    apiData,
    isLoading,
    actionTypes,
    riskTypes,
    catalogsLoaded,

    loadData,
    loadActionTypes,
    loadRiskTypes,
    setLoading: handleSetLoading,
    clearData: handleClearData,
  };
};
